import React from 'react';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { TOAST_PROMPT, requireToastContainer } from '../actions';

import Message from '../components/message';

const loadAndDisplayToast = async action => {
  const { toast } = await import(
    /* webpackChunkName: "toast" */ 'react-toastify'
  );

  return toast[action.promptType](
    <Message type={action.promptType}>{action.content}</Message>,
    action.options
  );
};

function* handleToastAction(action) {
  const toastContainerLoaded = yield select(state => state.toast.required);

  if (!toastContainerLoaded) {
    yield put(requireToastContainer());
  }

  yield call(loadAndDisplayToast, action);
}

function* toastSaga() {
  yield takeEvery(TOAST_PROMPT, handleToastAction);
}

if (IS_BROWSER) {
  window.registerSaga(toastSaga);
}

export default toastSaga;
